import ApiService from "@/utils/request";

export const collectServe = {
  list(params) {
    return ApiService.query("/policy/v2/inner/collection/", params);
  },
  del(id) {
    return ApiService.delete(`/policy/v2/inner/collection/${id}/`);
  },
  changeSms(params) {
    return ApiService.post("/policy/v2/inner/collection/sms/", params);
  },
};
